module.exports = __webpack_public_path__ + "fonts/iconfont.795f2d98.woff2";